import { get } from 'lodash-es'
import { toOffsetPaginatedList } from '../utils/toOffsetPaginatedList'

const toPlaceSuggestion = (data: Json): TPlaceSuggestion => ({
    placeId: get(data, 'placeId'),
    label: get(data, 'label'),
    description: get(data, 'description'),
})

export const toPlaceSuggestions = (data: Json): TOffsetPaginatedList<TPlaceSuggestion> =>
    toOffsetPaginatedList(data, toPlaceSuggestion)
